import { environment } from "environments/environment";

export const featureFlagsGlobalSettings:Record<string, boolean> = {
    enableScheduledJobCreation: !environment.production,
    enableNetsuitItemManagement: !environment.production,

}
